module.exports = __webpack_public_path__ + "static/media/click_here_to_exit.91f55310.svg";